import { createSlice } from '@reduxjs/toolkit';

export const initialState: any = {
    me: null,
    listStyleLiked: [],
    budgetDefault: [],
    genderDefault: [],
    bodyShapeDefault: [],
    bodyTypeDefault: [],
    personaDefault: [],
    myBirthday: '',
    skinToneDefault: null,
    patternDefault: null,
    skinUndertoneDefault: null,
    hairColorDefault: null,
    eyeColorDefault: null,
    fashionRestrictions: null,
    showOffDefault: null,
    coverDefault: null,
    pendingQuizzes: {},
    notifiedStylesId: [],
    generatingUserImage: false,
};
const userDetailSlice = createSlice({
    name: 'userDetail',
    initialState,
    reducers: {
        getMe: (state, action: any) => {
            state.me = action.payload;
        },
        setPendingQuizzes: (state, action) => {
            state.pendingQuizzes = action.payload;
        },
        setStyleQuizLiked: (state, action) => {
            state.listStyleLiked = action.payload;
        },
        setBudgetDefault: (state, action) => {
            state.budgetDefault = action.payload;
        },
        setBodyShapeDefault: (state, action) => {
            state.bodyShapeDefault = [
                {
                    title: action.payload,
                    value: action.payload,
                    isActive: true,
                    isShow: true,
                },
            ];
        },
        setBodyTypeDefault: (state, action) => {
            state.bodyTypeDefault = [
                {
                    title: action.payload,
                    value: action.payload,
                    isActive: true,
                    isShow: true,
                },
            ];
        },
        setPersonaDefault: (state, action) => {
            state.personaDefault = action.payload;
        },
        setMyBirthday: (state, action) => {
            state.myBirthday = action.payload;
        },
        setSkinToneDefault: (state, action) => {
            state.skinToneDefault = action.payload;
        },
        setPatternDefault: (state, action) => {
            state.patternDefault = action.payload;
        },
        setSkinUndertoneDefault: (state, action) => {
            state.skinUndertoneDefault = action.payload;
        },
        setHairColorDefault: (state, action) => {
            state.hairColorDefault = action.payload;
        },
        setEyeColorDefault: (state, action) => {
            state.eyeColorDefault = action.payload;
        },
        setFashionRestrictionDefault: (state, action) => {
            state.fashionRestrictions = action.payload;
        },
        setShowOffDefault: (state, action) => {
            state.showOffDefault = action.payload;
        },
        setCoverDefault: (state, action) => {
            state.coverDefault = action.payload;
        },
        setNotifiedStylesId: (state, action) => {
            state.notifiedStylesId = action.payload;
        },
        setGeneratingUserImage: (state, action) => {
            state.generatingUserImage = action.payload;
        },
    },
});

export const {
    getMe,
    setStyleQuizLiked,
    setBudgetDefault,
    setBodyShapeDefault,
    setBodyTypeDefault,
    setPersonaDefault,
    setMyBirthday,
    setSkinToneDefault,
    setPatternDefault,
    setSkinUndertoneDefault,
    setHairColorDefault,
    setEyeColorDefault,
    setFashionRestrictionDefault,
    setShowOffDefault,
    setCoverDefault,
    setPendingQuizzes,
    setNotifiedStylesId,
    setGeneratingUserImage,
} = userDetailSlice.actions;
const userDetailReducer = userDetailSlice.reducer;
export default userDetailReducer;
